import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getSuperAdminStatsAPI = createAsyncThunk(
    "getSuperAdminStatsAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.superAdminStats())
            return response.data
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getCorporatesStatsAPI = createAsyncThunk(
    "getCorporatesStatsAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.corporatesStats(id))
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)


const initialState = {
    loading: false,
    superAdminStats: "",
    corporatesStats: "",
}

const dashboardStatsSlice = createSlice({
    initialState,
    name: "dashboardStatsSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSuperAdminStatsAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(getSuperAdminStatsAPI.fulfilled, (state, action) => {
            state.loading = false
            state.superAdminStats = action.payload.data
        })

        builder.addCase(getSuperAdminStatsAPI.rejected, (state, action) => {
            state.loading = false
        })

        // GET CORPORATES STATS

        builder.addCase(getCorporatesStatsAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(getCorporatesStatsAPI.fulfilled, (state, action) => {
            state.loading = false
            state.corporatesStats = action.payload.data.data
        })

        builder.addCase(getCorporatesStatsAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = dashboardStatsSlice.actions
export default dashboardStatsSlice.reducer